import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import 'brace/theme/solarized_dark';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'cc-lg-code-box',
  templateUrl: './code-box.component.html',
  styleUrls: ['./code-box.component.scss']
})
export class CodeBoxComponent implements OnInit {
  @Input() mode: string;
  @Input() title: string;
  @Input() content: string;
  @Input() insertHtml = new Subject();
  @Output() codeChanged = new EventEmitter();
  @ViewChild('editor') editor;

  constructor() {}

  ngOnInit() {
    this.insertHtml.subscribe(html => {
      this.editorInstance.insert(html);
    });
  }

  onChange(code) {
    this.codeChanged.next(code);
  }

  get editorInstance() {
    return this.editor.nativeElement.env.editor;
  }
}
